// src/components/TechCloud.tsx
import { Container, Typography, Chip, Stack, Paper } from "@mui/material";

const techs = [
  { name: "Linux", color: "#FCC624" },
  { name: "Android", color: "#3DDC84" },
  { name: "Flutter", color: "#ED8B00" },
  { name: "PHP", color: "#777BB4" },
  { name: "Nodejs", color: "#049FD9" },
  { name: "MySQL", color: "#4479A1" },
];

export const TechCloud = () => (
  <Container sx={{ py: 10, textAlign: "center" }}>
    <Typography variant="h6" color="text.secondary" gutterBottom>
      OUR TECHNOLOGY ECOSYSTEM
    </Typography>
    <Paper elevation={0} sx={{ p: 4, bgcolor: "rgba(99, 91, 255, 0.05)", borderRadius: 4 }}>
      <Stack direction="row" spacing={2} flexWrap="wrap" justifyContent="center" useFlexGap>
        {techs.map((tech) => (
          <Chip
            key={tech.name}
            label={tech.name}
            sx={{
              fontWeight: "bold",
              fontSize: "1rem",
              p: 2,
              border: `2px solid ${tech.color}`,
              bgcolor: "white",
            }}
          />
        ))}
      </Stack>
    </Paper>
  </Container>
);
